import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LoginResponse, TokenLoginResponse, User, UserFriendsModel, UserStatisticsModel, UserWalletModel } from 'mvppoker-portal-common/api'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ActiveUser extends Partial<TokenLoginResponse> {
	recoverPasswordEmail?: string,
}

const initialState: ActiveUser = {
	recoverPasswordEmail: undefined
}

export const activeUserSlice = createSlice({
	name: 'ActiveUser',
	initialState,
	reducers: {
		forgotPasswordEmailChanged: (state, action: PayloadAction<string | undefined>) => {
			state.recoverPasswordEmail = action.payload
		},
		setActiveUser: (state, action: PayloadAction<LoginResponse>) => action.payload,
		clearActiveUser: (state) => initialState,
		updateWallet: (state, action: PayloadAction<UserWalletModel>) => {
			state.wallet = action.payload
		},
		updateUser: (state, action: PayloadAction<User>) => {
			state.user = action.payload
		},
		updateUserStatistics: (state, action: PayloadAction<UserStatisticsModel>) => {
			if (state.user) {
				state.user.statistics = action.payload
			}
		},
		updateUserFriends: (state, action: PayloadAction<UserFriendsModel>) => {
			if (state.user) {
				state.user.friends = action.payload
			}
		},
	},
})

export const { setActiveUser, clearActiveUser, updateWallet, updateUser, updateUserStatistics, updateUserFriends, forgotPasswordEmailChanged } = activeUserSlice.actions

export default activeUserSlice.reducer
